import { connect } from 'react-redux';
import { logout } from 'circe/authentication/actions';
import { getCurrentProfile } from 'domain/fuse/auth/selectors';
import { withRouter } from 'circe/routing/provider';
import { hide as hideNotification } from 'circe/notifications/actions';
import { getNotifications } from 'circe/notifications/selectors';
import { markAsEntered, markAsClosed, clearNotifications } from 'domain/fuse/firebase/actions';
import { getNewNotifications, getActiveNotifications } from 'domain/fuse/firebase/selectors';
import Layout from './components/Layout';
import { getCurrentPageTitle, isLoading } from './selectors';
import { setCurrentPageTitle } from './actions';

const mapStateToProps = (state, ownProps) => {
  const urlParams = new URLSearchParams(window.location.search);
  const isLogged = state.circe.authentication.logged;
  const {
    token, profileId, role, accountToken,
  } = getCurrentProfile(state);
  return {
    isLogged,
    hideSidebar: !isLogged || urlParams.has('hideSidebar'),
    authorities: state.circe.authorization.authorities,
    userData: state.circe.authentication.userData,
    canRoute: state.circe.authorization.canRoute,
    isAccountAdmin: role === 'ACCOUNT_ADMIN',
    accountAdminToken: role === 'ACCOUNT_ADMIN' ? token : '',
    accountToken,
    isLoading: isLoading(state, ownProps.location.pathname),
    notifications: getNotifications(state),
    currentPageTitle: getCurrentPageTitle(state),
    newNotifications: getNewNotifications(state),
    activeNotifications: getActiveNotifications(state),
  };
};
const mapDispatchToProps = (dispatch) => ({
  logout: () => {
    dispatch(logout());
  },
  setCurrentPageTitle: (title) => dispatch(setCurrentPageTitle(title)),
  hideNotification: (...props) => dispatch(hideNotification(...props)),
  markNotificationAsEntered: (id) => dispatch(markAsEntered(id)),
  markNotificationAsClosed: (id) => dispatch(markAsClosed(id)),
  clearNotifications: () => dispatch(clearNotifications()),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));
